import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=6fe66924"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fe66924')) {
      api.createRecord('6fe66924', component.options)
    } else {
      api.reload('6fe66924', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=6fe66924", function () {
      api.rerender('6fe66924', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notification-manager/edit.vue"
export default component.exports